import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon, UsersIcon, ClockIcon, UserIcon, SearchIcon } from 'lucide-react';
export function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navItems = [{
    icon: <HomeIcon size={24} data-id="element-164" />,
    label: 'Home',
    path: '/'
  }, {
    icon: <SearchIcon size={24} data-id="element-165" />,
    label: 'Discover',
    path: '/discovery'
  }, {
    icon: <ClockIcon size={24} data-id="element-166" />,
    label: 'Follow Up',
    path: '/follow-up'
  }, {
    icon: <UserIcon size={24} data-id="element-167" />,
    label: 'Profile',
    path: '/profile'
  }];
  return <div className="border-t border-gray-200" data-id="element-168">
      <nav className="flex justify-around py-3" data-id="element-169">
        {navItems.map((item, index) => <button key={index} onClick={() => navigate(item.path)} className={`flex flex-col items-center ${isActive(item.path) ? 'text-indigo-600' : 'text-gray-500'}`} data-id="element-170">
            <div className="mb-1" data-id="element-171">{item.icon}</div>
            <span className="text-xs" data-id="element-172">{item.label}</span>
          </button>)}
      </nav>
    </div>;
}